import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { submitReport } from "../lib/services";
import { formatApiError } from "../lib/api";

export default function ReportModal({ open, onClose, targetType, targetId, label }) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      toast("reason required");
      return;
    }
    setSubmitting(true);
    try {
      await submitReport({ targetType, targetId, reason: reason.trim() });
      toast("report submitted");
      setReason("");
      onClose();
    } catch (err) {
      toast(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="report-modal"
      className="fixed inset-0 z-[60] bg-black/80 flex items-end sm:items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md bg-black border-2 border-acid p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-baseline justify-between mb-3">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-acid">
              report
            </div>
            <div className="font-display text-2xl leading-tight mt-0.5">
              {label || targetType}
            </div>
          </div>
          <button
            data-testid="report-modal-close"
            onClick={onClose}
            className="text-white/60 hover:text-white"
            aria-label="close"
          >
            <X className="w-4 h-4" strokeWidth={2} />
          </button>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <textarea
            data-testid="report-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="what's the issue?"
            rows={4}
            autoFocus
            className="w-full bg-transparent border-2 border-white/30 px-3 py-2 font-mono text-sm placeholder:text-white/30 focus:border-acid outline-none resize-none"
          />
          <button
            type="submit"
            data-testid="report-submit"
            disabled={submitting}
            className="w-full bg-acid text-black font-mono text-sm uppercase tracking-wider py-3 border-2 border-acid hover:bg-black hover:text-acid transition-colors disabled:opacity-50"
          >
            {submitting ? "submitting..." : "submit report"}
          </button>
          <p className="font-mono text-[10px] text-white/40 text-center">
            admin reviews reports. no enforcement action in v0.1.
          </p>
        </form>
      </div>
    </div>
  );
}
